import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import validate from './validationStore'
import StoreFormDom from '../../../../../components/Screens/Estate/Store/Forms/StoreForm'
import Confirm from '../../../../../components/Confirm'
import { ObjectUtils, FormUtils } from '../../../../../utils'
import * as StoreActions from '../../../../../actions/stores'
import * as CountriesActions from '../../../../../actions/countries'
import * as ChainsActions from '../../../../../actions/chains'

class StoreForm extends PureComponent {
    static propTypes = {
        storeCode: PropTypes.string,
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        createStore: PropTypes.func.isRequired,
        storeUpdate: PropTypes.func.isRequired,
        fetchSingleStore: PropTypes.func.isRequired,
        fetchCountries: PropTypes.func.isRequired,
        fetchChains: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
        index: PropTypes.number,
        configs: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                value: PropTypes.shape({}).isRequired,
                created_at: PropTypes.string,
            })
        ),
    }

    static defaultProps = {
        isOpen: false,
        onClickCancel: () => null,
        storeCode: null,
        index: null,
        configs: null,
    }

    constructor(props) {
        super(props)

        this.state = {
            store: this.formatStoreToForm(),
            availableCountries: [],
            availableChains: [],
            fetchingData: true,
            isConfirmOpen: false,
            formErrors: {
                code: null,
                name: null,
                phone_primary: null,
                phone_secondary: null,
                email: null,
                slug: null,
                postcode: null,
                address: null,
                chain_id: null,
                country_code: null,
                lat: null,
                lng: null,
            },
            formConfig: 'DefaultStoreForm',
        }
    }

    async componentDidUpdate(prevProps) {
        const { isOpen, fetchSingleStore, storeCode, fetchCountries, fetchChains } = this.props
        const { isOpen: wasOpen } = prevProps
        const {
            StoreActions: { FETCH_SINGLE_STORE_SUCCESS },
        } = StoreActions
        const {
            Types: { COUNTRIES_FETCH_SUCCESS },
        } = CountriesActions
        let availableChains = []
        let availableCountries = []
        let store = null

        if (isOpen && isOpen !== wasOpen) {
            const responseAll = storeCode
                ? await Promise.all([fetchCountries(), fetchChains(), fetchSingleStore({ storeCode })])
                : await Promise.all([fetchCountries(), fetchChains()])

            if (storeCode) {
                const responseStore = responseAll[2]
                if (responseStore.type === FETCH_SINGLE_STORE_SUCCESS) {
                    const { payload } = responseStore
                    store = payload
                }
            }

            const responseCountries = responseAll[0]
            if (responseCountries.type === COUNTRIES_FETCH_SUCCESS) {
                const { payload } = responseCountries
                availableCountries = payload
                availableCountries = availableCountries.map((country) => {
                    const { code, name } = country
                    return {
                        ...country,
                        value: code,
                        name,
                    }
                })
            }

            const responseChains = responseAll[1]
            if (responseChains.type === ChainsActions.ChainsActions.CHAINS_FETCH_SUCCESS) {
                const { payload } = responseChains
                availableChains = payload
                availableChains = availableChains.map((chain) => {
                    const { id, name } = chain
                    return {
                        ...chain,
                        value: id.toString(),
                        name,
                    }
                })
            }

            store = this.formatStoreToForm(store, availableCountries)

            // As we are comparing the actual props with the prevProps to avoid infinite loops, we can use setState inside componentDidUpdate
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                availableChains,
                availableCountries,
                store,
                fetchingData: false,
            })
        }
    }

    isInConfig = (value, defaultValue) => {
        const { isInConfig } = FormUtils
        const { configs } = this.props
        const { formConfig } = this.state
        return isInConfig(formConfig, value, configs, defaultValue)
    }

    existInArray = (key, value, array, defaultValue) => {
        const { isInConfig, existInArray } = FormUtils
        const { configs } = this.props
        const { formConfig } = this.state
        const inArray = existInArray(value, array, '*default*')
        if (inArray !== '*default*') return inArray
        const valueToSearch = isInConfig(formConfig, key, configs, defaultValue)
        return valueToSearch
    }

    formatStoreToForm = (storeToFormat, availableCountries) => {
        let store = storeToFormat
        let form = {}
        if (!store) store = {}
        if (this.state) {
            form = {
                code: store.code || '',
                name: store.name || '',
                phone_primary: store.phone_primary || '',
                phone_secondary: store.phone_secondary || '',
                email: store.email || '',
                slug: store.slug || '',
                postcode: store.postcode || '',
                address: store.address || '',
                chain_id: this.isInConfig('chain_id', '1').toString(),
                country_code: this.existInArray('country_code', store.country_code, availableCountries),
                lat: store.lat || this.isInConfig('lat', '0'),
                lng: store.lng || this.isInConfig('lng', '0'),
            }
        }
        return form
    }

    onChangeFormValue = ({ target: { name, value } }) => {
        const { store } = this.state
        store[name] = value
        if (name === 'name' || name === 'code') store.slug = `${store.name.toLowerCase().replace(/ /g, '_')}_${store.code}`
        this.setState({ store }, this.forceUpdate())
    }

    onClickCancel = () => {
        const { onClickCancel } = this.props
        this.setState({
            store: this.formatStoreToForm(),
            fetchingData: true,
            isConfirmOpen: false,
        })
        onClickCancel()
    }

    buildOnchangeObject = () => {
        return {
            code: this.onChangeFormValue,
            name: this.onChangeFormValue,
            phone_primary: this.onChangeFormValue,
            phone_secondary: this.onChangeFormValue,
            email: this.onChangeFormValue,
            slug: this.onChangeFormValue,
            postcode: this.onChangeFormValue,
            address: this.onChangeFormValue,
            chain_id: this.onChangeFormValue,
            country_code: this.onChangeFormValue,
            lat: this.onChangeFormValue,
            lng: this.onChangeFormValue,
        }
    }

    updateDevice = async () => {
        const { storeUpdate, createStore, storeCode, index } = this.props
        const { store } = this.state
        const { StoreActions: actions } = StoreActions
        let response = null
        if (storeCode) response = await storeUpdate(store, storeCode, index)
        else response = await createStore(store)
        if (response.type === actions.UPDATE_STORE_SUCCESS || response.type === actions.CREATE_STORE_SUCCESS) {
            this.onClickCancel()
        }
    }

    onClickSubmit = () => {
        if (!this.validate()) {
            return
        }

        this.openCloseConfirm()
    }

    openCloseConfirm = () => {
        const { isConfirmOpen } = this.state
        this.setState({ isConfirmOpen: !isConfirmOpen })
    }

    onConfirm = () => {
        this.updateDevice()
    }

    /**
     * Form Validation
     */
    validate = () => {
        const { store } = this.state
        const formErrors = validate(store)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    renderConfirm = () => {
        const { isConfirmOpen } = this.state
        const { storeCode, t } = this.props
        return (
            <Confirm
                isOpen={isConfirmOpen}
                header={storeCode ? t('Edit store') : t('Create store')}
                content={storeCode ? `${t('EditStoreConfirmBody')} ${storeCode}?` : t('CreateStoreConfirmBody')}
                onClickCancel={() => this.openCloseConfirm()}
                onClickAccept={() => this.onConfirm()}
            />
        )
    }

    render() {
        const { isOpen, storeCode } = this.props
        const { formErrors, store, availableChains, availableCountries, storeLocations, fetchingData } = this.state
        if (store)
            return (
                <>
                    {this.renderConfirm()}
                    <StoreFormDom
                        ref={this.inputToFocus}
                        errors={formErrors}
                        isOpen={isOpen}
                        onChangeForm={this.buildOnchangeObject()}
                        onClickCancel={this.onClickCancel}
                        onClickSubmit={this.onClickSubmit}
                        store={store}
                        availableChains={availableChains}
                        availableCountries={availableCountries}
                        storeLocations={storeLocations}
                        storeCode={storeCode}
                        fetchingData={fetchingData}
                        onConfirm={this.onConfirm}
                    />
                </>
            )
        return (
            <>
                {this.renderConfirm()}
                <StoreFormDom
                    ref={this.inputToFocus}
                    errors={formErrors}
                    isOpen={isOpen}
                    onChangeForm={this.buildOnchangeObject()}
                    onClickCancel={this.onClickCancel}
                    onClickSubmit={this.onClickSubmit}
                    availableChains={availableChains}
                    availableCountries={availableCountries}
                    storeLocations={storeLocations}
                    store={store}
                    storeCode={storeCode}
                    fetchingData={fetchingData}
                    onConfirm={this.onConfirm}
                />
            </>
        )
    }
}

const mapStateToProps = ({ configs: { configs } }) => ({
    configs,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...StoreActions,
            ...ChainsActions,
            ...CountriesActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StoreForm))
